export const SITE_ORIGIN = 'https://flashwebrennes.online';
export const SITE_LANGUAGES = ['fr', 'en', 'ar'] as const;
export type SiteLanguage = typeof SITE_LANGUAGES[number];
export const pageMetaKeys: Record<string, string> = {
  '/': 'home', '/blog': 'blog', '/audit': 'audit',
  '/outils/concurrents': 'competitor_gap',
  '/mentions-legales': 'legal', '/politique-confidentialite': 'privacy', '/cgv': 'cgv',
  '/applications-bots-discord': 'applications',
  '/creation-site-internet-rennes': 'local_service',
  '/creation-site-e-commerce-rennes': 'local_service',
  '/refonte-site-internet-rennes': 'local_service',
};
const FRENCH_ONLY_PAGES = new Set([
  '/creation-site-internet-rennes',
  '/creation-site-e-commerce-rennes',
  '/refonte-site-internet-rennes',
]);
export function supportsLanguageAlternates(pathname: string): boolean {
  const clean = pathname.replace(/\/+$/, '') || '/';
  return Boolean(pageMetaKeys[clean]) && !FRENCH_ONLY_PAGES.has(clean);
}
export function siteLanguage(value: unknown): SiteLanguage {
  return value === 'en' || value === 'ar' ? value : 'fr';
}
export function canonicalUrl(pathname: string, lang: SiteLanguage = 'fr'): string {
  const clean = pathname.replace(/\/+$/, '') || '/';
  // Articles have their own language-specific slugs. Product content is French.
  const translated = supportsLanguageAlternates(clean);
  return `${SITE_ORIGIN}${clean}${translated && lang !== 'fr' ? `?lang=${lang}` : ''}`;
}
export function safeJson(value: unknown): string {
  return JSON.stringify(value).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}
